import { render, staticRenderFns } from "./PopupLayoutDefault.vue?vue&type=template&id=445e2119&scoped=true&"
import script from "./PopupLayoutDefault.vue?vue&type=script&lang=js&"
export * from "./PopupLayoutDefault.vue?vue&type=script&lang=js&"
import style0 from "./PopupLayoutDefault.vue?vue&type=style&index=0&id=445e2119&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445e2119",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VDivider,VProgressLinear})
